import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sprints-home-item" }
const _hoisted_2 = {
  key: 0,
  class: "text-deEmphasised-text flex text-sm"
}
const _hoisted_3 = { class: "" }

import ListOfBoardsItem from '@/components/widgets/ListOfBoardsItem.vue';
import { Sprint } from '@superthread-com/api';
import { convertTimestampToDate } from '@/utilities/timeDifference';
import useTranslate from '@/utilities/composables/useTranslate';
import SortHeaderTitle from '@/components/widgets/SortHeaderTitle';
import { fromUnixTime, isWithinInterval, addDays, subDays, getUnixTime } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'SprintsHomeItem',
  props: {
    sprintIds: {},
    sprintsCoolDownPeriod: {},
    spaceSprints: {},
    headerText: {},
    buttonText: {},
    buttonIcon: {},
    iconRightPosition: { type: Boolean },
    showIcon: { type: Boolean },
    emptyStateText: {}
  },
  emits: ['clickHandler'],
  setup(__props: any, { emit: __emit }) {

const { translate } = useTranslate();

const props = __props;

const emit = __emit;

const getCooldDownDates = (sprintId: string, index: number) => {
  const sprint = props.spaceSprints.find((sprint) => sprint.id === sprintId);
  const nextSprint = props.spaceSprints[index + 1];

  if (!nextSprint || !sprint || !sprint.start_date || !nextSprint.end_date)
    return { startDate: null, endDate: null };

  const startDate = addDays(fromUnixTime(nextSprint.end_date), 1);
  const endDate = subDays(fromUnixTime(sprint.start_date), 1);

  return {
    startDate: getUnixTime(startDate),
    endDate: getUnixTime(endDate),
  };
};

const getCooldownPeriodDate = (sprintId: string, index: number): string => {
  const { startDate, endDate } = getCooldDownDates(sprintId, index);

  if (!startDate || !endDate) return '';

  return `${convertTimestampToDate(startDate)} - ${convertTimestampToDate(endDate)}`;
};

const isCoolDownPeriodActive = (sprintId: string, index: number): boolean => {
  const { startDate, endDate } = getCooldDownDates(sprintId, index);
  if (!startDate || !endDate) return false;

  const currentDate = new Date();

  return isWithinInterval(currentDate, {
    start: fromUnixTime(startDate),
    end: fromUnixTime(endDate),
  });
};

const clickHandler = () => {
  emit('clickHandler');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SortHeaderTitle), {
      title: _ctx.headerText,
      "button-text": _ctx.buttonText,
      "icon-right-position": _ctx.iconRightPosition,
      "icon-name": _ctx.buttonIcon,
      "show-icon": _ctx.showIcon,
      class: "-mb-2",
      onClick: clickHandler
    }, null, 8, ["title", "button-text", "icon-right-position", "icon-name", "show-icon"]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (!_ctx.sprintIds.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.emptyStateText), 1))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sprintIds, (sprintId, index) => {
      return (_openBlock(), _createElementBlock("div", { key: sprintId }, [
        _createVNode(ListOfBoardsItem, {
          "item-id": sprintId,
          "board-index": index,
          "item-type": 'sprint'
        }, null, 8, ["item-id", "board-index"]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (_ctx.sprintsCoolDownPeriod && index < _ctx.sprintIds.length - 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["cooldown-period", { 'active-cooldown': isCoolDownPeriodActive(sprintId, index) }])
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(translate)('coolDown')), 1),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _createElementVNode("span", null, _toDisplayString(getCooldownPeriodDate(sprintId, index)), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})